import { render } from "./Orkos.vue?vue&type=template&id=02234fe8&scoped=true"
import script from "./Orkos.vue?vue&type=script&lang=js"
export * from "./Orkos.vue?vue&type=script&lang=js"

import "./Orkos.vue?vue&type=style&index=0&id=02234fe8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02234fe8"]])

export default __exports__